import React, { useEffect , useState} from 'react';
import { connect } from 'react-redux';
import { nextStep, dropFiles } from '../redux/actions/actions';
import Dropzone from "react-dropzone";
import { Pano360ImageInfoDiv } from './constants/infoConstants';

const UploadPanoramaLib = (props) => {
    const [showUserinfoDiv, setShowUserinfoDiv] = useState(false);
    
    const Cancel = () => {
        props.nextStep("360 library", props.prev_step)
    }

    const handleDrop = (files) => {        
        files.sort(function(imga, imgb){
            if(imga.path < imgb.path) { return -1; }
            if(imga.path > imgb.path) { return 1; }
            return 0;
        })

        props.dropFiles(files, "360 lib");
        if(props.prev_step === "template"){
            props.nextStep("upload files", "template");
        } else if (props.prev_step === "360 library") {
            props.nextStep("upload files", "360 library");
        } else {
            props.nextStep("upload files", "not redirect lib");
        }
    }

    useEffect(() => {
        if(props.setShowTools)
            props.setShowTools(false);
    }, [])

    return (
        <div>
        <h1 className='userHelpCircle' onClick={() => setShowUserinfoDiv(!showUserinfoDiv)}>?</h1>
            <div className="uploadImages">
                <Dropzone onDrop={handleDrop}>
                    {({ getRootProps, getInputProps }) => (
                        <div {...getRootProps({ className: "dropzone" })}>
                            <h3>Drop 360 panoramas here</h3><br/>
                            <h3>Or</h3><br/>
                            <input {...getInputProps()} />
                            <button>Choose files</button><br/>
                        </div>

                    )}
                </Dropzone>
                {props.type !== 'edit' ? <div className="cancel">
                    <h3>Or</h3><br/>
                    <button className="cancel_btn" onClick={()=>{
                        // if(props.prev_step === "template"){
                        //     props.nextStep("scale layout", "template");
                        // } 
                        if(props.prev_step === "template"){
                            props.nextStep("cams position", "template");
                        } 
                        else if (props.prev_step === "360 libraryy") {
                            props.nextStep("360 library", "_");
                        } 
                        else if (props.prev_step === "new level" && props.ifloorplanNowState.level.length > 1) {
                            props.nextStep("image library", "new level");
                        }else {
                            props.nextStep('cams position', "not redirect lib");
                        }
                    }}>No thanks - Continue</button>
                </div>: <div className="cancelBtnBlue"><button onClick={Cancel}>Cancel</button></div>}
            
            {showUserinfoDiv ? <Pano360ImageInfoDiv /> : ''}

            </div>
        </div>
    );
}

const putState = (state) => {
    return {
        step: state.step,
        prev_step: state.prev_step,
        ifloorplanNowState: state.ifloorplanNowState
    }
}

const putActions = (dispatch) => {
    return {
        nextStep: (step, prevStep) => dispatch(nextStep(step, prevStep)),
        dropFiles: (files, title) => dispatch(dropFiles(files, title))
    }
}

export default connect(putState, putActions) (UploadPanoramaLib);